/**
 * useCloseOnScroll
 * Hook utilitário para fechar dropdowns ao rolar a página.
 * 
 * Uso:
 * ```tsx
 * useCloseOnScroll(() => setIsOpen(false), isOpen);
 * ```
 */
import { useEffect } from 'react';

export function useCloseOnScroll(
    onClose: () => void,
    enabled: boolean = true
): void {
    useEffect(() => {
        if (!enabled) return;

        const handleScroll = () => {
            onClose();
        };

        // Usa capture para pegar scroll em qualquer elemento
        window.addEventListener('scroll', handleScroll, { capture: true, passive: true });
        return () => window.removeEventListener('scroll', handleScroll, { capture: true });
    }, [onClose, enabled]);
}

export default useCloseOnScroll;
